<template>
  <FadeIn 
  class="bg-white rounded-[20px] flex flex-col lg:flex-col lg:items-center max-w-[1180px] border-2 border-[#e8e5de]"
  >
  <div 
    class="flex-1 flex justify-center"
    >
      <div 
      class="px-4 py-4 lg:p-6"
      :class="[sectionIndex % 2 ? 'ml-auto' : 'mr-auto']"
      >
        <div class="mb-2 md:mb-4" v-if="content.pretitle">
          <span class="rounded-full mr-2 sm:mr-0 mb-2 sm:mb-0 bg-[#5a6ded] px-2 py-0 text-xs inline-block font-semibold leading-6 text-white no-underline">
            {{ content.pretitle }}
          </span>
        </div>
        
        <h2 v-if="content.heading === 'h2'" class="text-xl sm:text-2xl font-bold tracking-tight text-gray-900">
          {{ content.title }}
        </h2>
        <h3 v-else class="text-xl sm:text-2xl font-bold tracking-tight text-gray-900">
          {{ content.title }}
        </h3>
        
        <div 
        v-if="content.content"
        v-interpolation 
        v-html="useSanitize(content.content, currentLocale)" 
        class="text-sm mt-2 sm:mt-4 prose">
        </div>

        <div 
        v-if="content?.cta?.url"
        class="mt-8"
        >
          <ElementButton
          :url="content.cta.url" 
          :type="content.cta.type"
          :arrow="content.cta.arrow"
          >
            {{ content.cta.title}}
          </ElementButton>
        </div> 

      </div>
    </div>
    <div
    class="lg:px-0 h-auto flex-1 w-full"
    :class="brickClasses"
    >
      <div class="mx-auto max-w-2xl sm:mx-0 sm:max-w-none border-t border-[#e8e5de]">
        
        <LottiePlayer
        v-if="content?.lottie"
        :src="`https://media.elker.com/${content?.lottie.id}/${content?.lottie.filename_download}`"
        wrapper-class="rounded-t-0 rounded-b-[18px] md:rounded-t-0 overflow-hidden"
        />

        <ImageResponsive
        v-else-if="content?.image"
        classes="rounded-b-[18px] md:rounded-b-[18px] rounded-t-0 md:rounded-t-0 ring-1 ring-white/10 bg-[#f3f1ec]"
        :data="content?.image"
        :lazy="true"
        :xs="12"
        :sm="6"
        :md="6"
        :lg="6"
        :xl="6"
        />
      </div>
    </div>
  </FadeIn>
</template>

<script setup>
const props = defineProps({
  content: {
    type: Object,
    required: true,
  },
  sectionIndex: {
    type: Number
  },
  hasTitle: {
    type: String,
    default: null
  }
})

const brickClasses = computed(() => {
  let brickClass = ''
  // if (props.content?.imgGap) {
  //   if (props.sectionIndex && props.sectionIndex % 2 === 0) {
  //     brickClass += 'lg:pl-10'
  //   } else {
  //     brickClass += 'lg:pr-10'
  //   }
  // }
  // if (props.sectionIndex && props.sectionIndex % 2 === 1) {
  //   brickClass += ''
  // } else {
  //   brickClass += ' lg:order-1'
  // }
  return brickClass
})

const route = useRoute()
const currentLocale = computed(() => {
  return route.path.startsWith('/nz') ? 'nz' : 'au'
})

</script>

<style scoped lang="scss">
.prose {
  ul {
    li {
      margin-bottom: 0;
    }
  }
}
</style>